export const key = (state) => state.closeTheLoop.key;
export const dashboardKey = (state) => state.closeTheLoop.dashboardKey;
